import React from 'react';
import { Link, useLocation, Navigate } from 'react-router-dom';
import { RESEARCH_SUPPORT_BASE } from '../../constants/researchSupport';

function SubmissionSuccess() {
  const { state } = useLocation();

  if (!state?.submissionId) {
    return <Navigate to={`${RESEARCH_SUPPORT_BASE}/apply`} replace />;
  }

  return (
    <div className="max-w-lg mx-auto text-center py-12">
      <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-green-100 flex items-center justify-center text-2xl text-green-700">
        ✓
      </div>
      <h1 className="text-2xl font-bold text-gray-900 mb-3">Application submitted</h1>
      <p className="text-gray-600 mb-2">
        Your research project <strong>{state.researchTitle}</strong> has been received.
      </p>
      <p className="text-sm text-gray-500 mb-8">
        Reference ID: <code className="bg-gray-100 px-2 py-1 rounded">{state.submissionId}</code>
        <br />
        A confirmation email will be sent shortly.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link
          to={`${RESEARCH_SUPPORT_BASE}/my-submissions`}
          className="px-6 py-3 bg-iof text-white rounded-full font-medium hover:bg-iof-dark"
        >
          View my submissions
        </Link>
        <Link
          to={RESEARCH_SUPPORT_BASE}
          className="px-6 py-3 border border-iof text-iof rounded-full font-medium hover:bg-iof/5"
        >
          Back to overview
        </Link>
      </div>
    </div>
  );
}

export default SubmissionSuccess;
